import React__default from 'react';
import { toast } from '../../../node_modules/react-toastify/dist/react-toastify.esm.js';
import '../alert/Alert.js';
import '../aspect-image/AspectImage.js';
import '../aspect-ratio/AspectRatio.js';
import '../badge/Badge.js';
import { Box } from '../box/Box.js';
import '../button/Button.js';
import '../card/Card.js';
import '../checkbox/Checkbox.js';
import 'tslib';
import '../collapse/CollapseContext.js';
import '../collapse/CollapseHeader.js';
import '../collapse/CollapsePanel.js';
import '../theme/defaultToolkitTheme.js';
import '../theme/vmTheme.js';
import '../theme/wmTheme.js';
import '../theme/GlobalStyle.js';
import '../theme/ThemeProvider.js';
import '../discount-badge/DiscountBadge.js';
import '../field-error-message/FieldErrorMessage.js';
import '../filter-item/FilterItem.js';
import '../flex-grid/FlexGridContext.js';
import '../flex-grid/Row.js';
import '../footer/Footer.js';
import '../grid/Grid.js';
import '../heading/Heading.js';
import '../icon/Icon.js';
import '../text/Text.js';
import '../icon-label/IconLabel.js';
import '../image/Image.js';
import '../input/Input.js';
import '../label/Label.js';
import '../link/Link.js';
import '../list/List.js';
import '../list/ListIcon.js';
import '../loading-wheel/LoadingWheel.js';
import '../logo/Logo.js';
import '../overlay/Overlay.js';
import '../modal/FullscreenModal.js';
import '../popover/Popover.js';
import '../price-button/PriceButton.js';
import '../product-price/ProductPrice.js';
import '../banners/PushNotificationBanner.js';
import '../radio/Radio.js';
import '../ribbon/Ribbon.js';
import '../search-input/SearchInput.js';
import '../section/Section.js';
import '../select/Select.js';
import '../stack/Stack.js';
import '../time-display/TimeDisplay.js';
import './ToastContainer.js';
import '../toggle-switch/ToggleSwitch.js';
import '../tooltip/ToolTip.js';
import '../vm-logo/VmLogo.js';
import '../vm-split-logo/VmSplitLogo.js';

var openToast = function (children, options) {
  if (options === void 0) {
    options = {};
  }
  return toast(React__default.createElement(Toast, null, children), options);
};
var Toast = function (_a) {
  var children = _a.children;
  return React__default.createElement(Box, {
    width: "100%",
    height: "100%"
  }, children);
};

export { Toast, openToast };
//# sourceMappingURL=Toast.js.map
